export function injectScript(request) {
    request.forEach((script) => {
        const { hid, src, callback } = script;
        const s = document.createElement("script");
        s.src = src;
        s.id = hid;
        s.onload = callback;
        document.head.appendChild(s);
    });
}
